// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 687 ? "create" : chunkId) + "." + {"214":"8a43d000","687":"81dce1a9"}[chunkId] + ".chunk.css";
};